import React from 'react';
import { Popup, TextInput } from '@gravity-ui/uikit';
import isNumber from 'is-number';
import { cn } from '../../../../../classname';
import { LinkAttr, linkType } from '../../../../../extensions/markdown';
import { ImgSizeAttr } from '../../../../../extensions/specs';
import Form from '../../../../../forms/base';
import { NumberInput } from '../../../../../forms/components';
import { enterKeyHandler } from '../../../../../forms/utils';
import { i18n } from '../../../../../i18n/forms';
import './ImageForm.css';
const b = cn('image-tooltip-form');
export const ImageForm = ({ node, updateAttributes, view, unsetEdit, dom }) => {
    const { attrs, marks } = node;
    const link = marks.find((m) => m.type.name === linkType(view.state.schema).name);
    const [name, setName] = React.useState(attrs[ImgSizeAttr.Title] || '');
    const [alt, setAlt] = React.useState(attrs[ImgSizeAttr.Alt] || '');
    const [width, setWidth] = React.useState(attrs[ImgSizeAttr.Width] || '');
    const [height, setHeight] = React.useState(attrs[ImgSizeAttr.Height] || '');
    const [linkHref, setLinkHref] = React.useState((link === null || link === void 0 ? void 0 : link.attrs.href) || '');
    const handleSubmit = () => {
        updateAttributes({
            title: name.trim(),
            alt: alt.trim(),
            width: isNumber(width) && Number(width) >= 0 ? String(width) : '',
            height: isNumber(height) && Number(height) >= 0 ? String(height) : '',
        }, link
            ? [
                linkType(view.state.schema).create(Object.assign(Object.assign({}, link.attrs), { [LinkAttr.Href]: linkHref })),
            ]
            : []);
        unsetEdit();
    };
    const inputEnterKeyHandler = enterKeyHandler(handleSubmit);
    return (React.createElement(Popup, { open: true, anchorRef: dom, placement: ['bottom-start', 'top-start', 'bottom-end', 'top-end'], onOutsideClick: unsetEdit },
        React.createElement(Form.Form, { className: b() },
            React.createElement(Form.Layout, null,
                link && (React.createElement(Form.Row, { label: i18n('image_link_href'), help: i18n('image_link_href_help'), control: React.createElement(TextInput, { autoFocus: true, size: "s", view: "normal", value: linkHref, onUpdate: setLinkHref, className: b('input', { type: 'link' }), onKeyPress: inputEnterKeyHandler }) })),
                React.createElement(Form.Row, { label: i18n('image_name'), control: React.createElement(TextInput, { autoFocus: Boolean(!link), size: "s", view: "normal", value: name, onUpdate: setName, className: b('input', { type: 'name' }), onKeyPress: inputEnterKeyHandler }) }),
                React.createElement(Form.Row, { label: i18n('image_alt'), help: i18n('image_alt_help'), control: React.createElement(TextInput, { size: "s", view: "normal", value: alt, onUpdate: setAlt, className: b('input', { type: 'alt' }), onKeyPress: inputEnterKeyHandler }) }),
                React.createElement(Form.Row, { label: i18n('common_sizes'), control: React.createElement("div", { className: b('size-controls') },
                        React.createElement(NumberInput, { min: 0, size: "s", view: "normal", value: width, onUpdate: setWidth, placeholder: i18n('image_size_width'), className: b('input', { type: 'width' }), onKeyPress: inputEnterKeyHandler }),
                        "x",
                        React.createElement(NumberInput, { min: 0, size: "s", view: "normal", value: height, onUpdate: setHeight, placeholder: i18n('image_size_height'), className: b('input', { type: 'height' }), onKeyPress: inputEnterKeyHandler })) })),
            React.createElement(Form.Footer, { onSubmit: handleSubmit }))));
};
